<template>
  <div class="changeBudgetStructure">
    <el-table
      :data="changeBudgetList"
      style="width: 100%"
    >
      <el-table-column
        v-for="[key, val] of Object.entries(changeBudgetStructure)"
        :key="key"
        :prop="key"
        :label="val"
      >
        <template slot-scope="scope">
          {{ scope.row[key] === null ? '-' : scope.row[key] }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { changeBudgetStructure } from '../models'
export default {
  data () {
    return {
      changeBudgetStructure,
      selectedYears: this.$route.params.selectedYears,
      changeBudgetList: []
    }
  },
  watch: {
    $route (to, from) {
      this.selectedYears = to.params.selectedYears
      this.getBudget()
    }
  },
  mounted () {
    this.getBudget()
  },
  methods: {
    async getBudget () {
      try {
        const { data } = await apiAsset.maintenance.getCostEstimationReplacement(this.selectedYears)
        this.changeBudgetList = data
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.changeBudgetStructure {
    ::v-deep .el-table {
  @include basicTable();
}
}
</style>
